var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCnx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#4C6BAE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59044 9.5681L2.8125 9.64854C3.22875 8.48416 4.05169 7.55266 5.28244 6.85404C5.39887 7.81929 5.85619 8.61747 6.65494 9.24972L5.92369 9.32566C5.99493 9.99708 6.28375 10.6268 6.74612 11.1188C7.20849 11.6108 7.81905 11.9382 8.48475 12.051C7.99455 12.4197 7.41424 12.6499 6.80456 12.7175C7.18762 13.3925 7.641 13.9455 8.16412 14.3752C6.9784 14.1904 5.88702 13.6188 5.05983 12.7494C4.23264 11.88 3.71605 10.7616 3.59044 9.5681ZM14.4096 8.43185L15.1875 8.35141C14.7712 9.51579 13.9483 10.4473 12.7176 11.1459C12.6011 10.1807 12.1438 9.38247 11.3451 8.75022L12.0763 8.67428C12.0043 7.99578 11.7102 7.36006 11.2396 6.86598C10.769 6.37191 10.1484 6.04715 9.47419 5.94222C9.96272 5.5773 10.5399 5.34951 11.1459 5.28241C10.7595 4.60235 10.3028 4.04716 9.77456 3.61572C10.9728 3.78852 12.0792 4.35596 12.9187 5.22825C13.7582 6.10055 14.2828 7.22787 14.4096 8.43185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5186 14.4146L9.59904 15.1875C8.43466 14.7712 7.50316 13.9483 6.80454 12.7176C7.76922 12.6011 8.56741 12.1438 9.19966 11.3451L9.27616 12.0819C9.96434 12.0201 10.612 11.7297 11.1161 11.2572C11.6202 10.7846 11.9516 10.1569 12.0577 9.47419C12.4226 9.96272 12.6504 10.5399 12.7175 11.1459C13.3976 10.7595 13.9528 10.3028 14.3842 9.77456C14.2102 10.9812 13.636 12.0945 12.7538 12.9359C11.8715 13.7773 10.7322 14.2981 9.5186 14.4146ZM8.43185 3.59044L8.35141 2.8125C9.51579 3.22875 10.4473 4.05169 11.1459 5.28244C10.1807 5.39887 9.38247 5.85619 8.75022 6.65494L8.67428 5.92369C7.99578 5.99567 7.36006 6.28982 6.86598 6.76039C6.37191 7.23097 6.04715 7.85161 5.94222 8.52581C5.5773 8.03728 5.34951 7.46014 5.28241 6.85406C4.60235 7.2405 4.04716 7.69725 3.61572 8.22544C3.78852 7.0272 4.35596 5.9208 5.22825 5.08132C6.10055 4.24183 7.22787 3.7172 8.43185 3.59044Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnx);
export default __webpack_public_path__ + "static/media/cnx.1980d0bea87c2a73121f5565517aaa00.svg";
export { ForwardRef as ReactComponent };